document.querySelectorAll("[data-customer-logos]").forEach((section) => {
    const viewport = section.querySelector(".customer-logos__viewport");
    const track = section.querySelector(".customer-logos__track");
    const list = section.querySelector(".customer-logos__list");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let clone;

    const update = () => {
        const gap = parseFloat(getComputedStyle(list).columnGap);
        const items = [...list.children];
        const width =
            items.reduce((sum, item) => sum + item.getBoundingClientRect().width, 0) +
            gap * items.length;
        const animate = !reducedMotion.matches && width - gap > viewport.clientWidth;

        if (animate && !clone) {
            clone = list.cloneNode(true);
            clone.setAttribute("aria-hidden", "true");
            clone.querySelectorAll("a").forEach((link) => {
                link.tabIndex = -1;
            });
            track.append(clone);
        }

        section.toggleAttribute("data-animated", animate);
        // A fixed distance per second keeps the pace consistent as editors add logos.
        section.style.setProperty("--logo-duration", `${width / 60}s`);
    };

    reducedMotion.addEventListener("change", update);
    new ResizeObserver(update).observe(viewport);
    update();
});
